export default __webpack_public_path__ + "assets/webgl/pause.39bedae7.png";